import PipscLogo from '@nv/images/logos/pipsc-voter-portal/pipsc-logo'
import PipscLogoCollapsed from '@nv/images/logos/pipsc-voter-portal/pipsc-logo-collapsed'

export const pipscTheme = {
  bgColor: 'var(--color-white)',
  textColor: 'var(--color-black)',
  Logo: PipscLogo,
  MobileLogo: PipscLogoCollapsed,
}
